import Vue from 'vue'
import Router from 'vue-router'

//Pages
import Home from '../pages/Home/Home/Router'
import MinhaConta from '../pages/Inicio/MinhaConta/Router'
import Logs from '../pages/Logs/Logs/Router'

import Classificados from '../pages/Sistema/Classificados/Router'
import Galerias from '../pages/Sistema/Galerias/Router'
import Destaques from '../pages/Sistema/destaques/Router'
import Noticias from '../pages/Sistema/Noticias/Router'
import Paginas from '../pages/Sistema/Paginas/Router'
import Publicidades from '../pages/Sistema/Publicidades/Router'
import Videos from '../pages/Sistema/Videos/Router'
import GrupoDeAcesso from '../pages/Admin/GrupoDeAcesso/Router'
import Usuarios from '../pages/Admin/Usuarios/Router'
import Categorias from '../pages/Admin/Categorias/Router'

import Redirect from '../pages/redirect/Index/Router'
import Acessar from '../pages/Login/Acessar/Router'
import Erro from '../pages/Erro/404/Router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		...Redirect,
		{
			path: '/',
			component: () => import('@/layouts/Default'),
			children: [
				...Home,
				...MinhaConta,
				...Logs,
				...Classificados,
				...Galerias,
				...Destaques,
				...Noticias,
				...Paginas,
				...Publicidades,
				...Videos,
				...GrupoDeAcesso,
				...Usuarios,
				...Categorias
			]
		},
		...Acessar,
		...Erro,
	]
})